var Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    defaults: {
        firstAuthComplete: false, // flag used in determining logout reason
        userAuthenticated: false,
        logOutReason: null, // 'initialViewerRender' or 'sessionTimeout' or 'validationError' or 'userLoggedOut'
        logInErrorMessage: null
    },
    login: function() {
        this.set({
            userAuthenticated: true,
            firstAuthComplete: !this.get('firstAuthComplete'), //TODO: enum xref
            logOutReason: null,
            logInErrorMessage: null
        });
    },
    logout: function(options) {

        var reason = null,
            logInErrorMsg = null,
            userLogOut = options && options.fromLogOut,
            authErr = options && options.authErr,
            firstAuthCompleted = this.get('firstAuthComplete');

        if (!firstAuthCompleted && !authErr) {
            reason = 'initialViewerRender';
        } else if (userLogOut) {
            reason = 'userLoggedOut';
        } else if (authErr) {
            reason = 'validationError';
        } else if (firstAuthCompleted && !authErr){
            reason = 'sessionTimeout';
        }

        if (!userLogOut && firstAuthCompleted && !authErr) {
            logInErrorMsg = 'Session expired.  Please log back in.';
        } else if (authErr) {
            logInErrorMsg = 'Invalid Login Credentials';
        }

        this.set({
            firstAuthComplete: firstAuthCompleted,
            userAuthenticated: false,
            logOutReason: reason,
            logInErrorMessage: logInErrorMsg
        });
    },
    didSessionTimeout: function() {
        return this.get('logOutReason') && this.get('logOutReason') === 'sessionTimeout';
    },
    firstAuthCompleted: function() {
        return this.get('firstAuthComplete');
    },
    loginErr: function() {
        return this.get('logInErrorMessage');
    },
    isAuthenticated: function() {
        return this.get('userAuthenticated');
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/authentication/authState.js
 ** module id = 760
 ** module chunks = 0
 **/